export var SurveyQuestionNumberType;
(function (SurveyQuestionNumberType) {
    SurveyQuestionNumberType[SurveyQuestionNumberType["Number"] = 0] = "Number";
    SurveyQuestionNumberType[SurveyQuestionNumberType["Currency"] = 1] = "Currency";
    SurveyQuestionNumberType[SurveyQuestionNumberType["Unit"] = 2] = "Unit";
})(SurveyQuestionNumberType || (SurveyQuestionNumberType = {}));
